export default "__VITE_ASSET__DLq1mPeo__"